// lib/ablyClient.ts
import * as Ably from 'ably';

let ably: Ably.Realtime | null = null;

function getClient(): Ably.Realtime {
  if (!ably) {
    ably = new Ably.Realtime({
      key: process.env.NEXT_PUBLIC_ABLY_KEY!,
    });
  }
  return ably;
}

function closeSocket() {
  ably?.close();
  ably = null;
}

export const socketClient = {
  getClient,
  closeSocket,
};
